import { Injectable, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AppStateChangeService } from './app-state-change.service';
import { SubscriptionsBag } from '@utils/subscriptions-bag';

@Injectable({
  providedIn: 'root'
})
export class OnlineStateService implements OnDestroy {
  private readonly appStateChangeService = inject(AppStateChangeService);

  private isOfflineSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isOffline$: Observable<boolean> = this.isOfflineSubject.asObservable();
  private sb: SubscriptionsBag = new SubscriptionsBag();

  constructor() {
    this.subscribeToWindowEvents();
    this.subscribeToAppState();
  }

  ngOnDestroy() {
    this.sb.unsubscribeAll();
  }

  /* set isOffline(value: boolean) { // from socket controller, if socket is disconnected
    this.isOfflineSubject.next(value);
  } */

  get isOffline(): boolean {
    return this.isOfflineSubject.value;
  }

  private subscribeToWindowEvents(): void {
    if (typeof window === 'undefined') return;

    this.sb.sub = fromEvent(window, 'online').subscribe((): void => {
      console.log('\x1b[32m' + 'You are online' + '\x1b[0m');
      this.isOfflineSubject.next(false);
    });

    this.sb.sub = fromEvent(window, 'offline').subscribe((): void => {
      console.log('\x1b[31m' + 'You are offline!' + '\x1b[0m');
      this.isOfflineSubject.next(true);
    });
  }

  private subscribeToAppState(): void {
    this.sb.sub = this.appStateChangeService.appStateChange$.pipe(
      filter((isActive: boolean): boolean => isActive),
      distinctUntilChanged(),
    ).subscribe((): void => {
      if (typeof navigator !== 'undefined') {
        console.log((navigator.onLine) ? '\x1b[32m' + 'You are online' + '\x1b[0m' : '\x1b[31m' + 'You are offline' + '\x1b[0m');
        this.isOfflineSubject.next(!navigator.onLine);
      } else {
        this.isOfflineSubject.next(false);
      }
    });
  }
}
